// extracted by mini-css-extract-plugin
export default {"container":"notificationMsg_container__S2s98","notiContent":"notificationMsg_notiContent__014tj"};